// High-quality Indian property images via Unsplash
export const propertyImages = {
  // Hero/Video backgrounds
  heroVideo: null, // Will use YouTube embed or placeholder

  // Indian architecture & luxury properties
  villa1: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1600&q=90',
  villa2: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=90',
  villa3: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=1600&q=90',
  apartment1: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1600&q=90',
  apartment2: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1600&q=90',
  penthouse1: 'https://images.unsplash.com/photo-1574362848149-11496d93a7c7?w=1600&q=90',
  commercial1: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1600&q=90',
  pool1: 'https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=1600&q=90',
  interior1: 'https://images.unsplash.com/photo-1618219908412-a29a1bb7b86e?w=1600&q=90',
  interior2: 'https://images.unsplash.com/photo-1616137466211-f939a420be84?w=1600&q=90',
  interior3: 'https://images.unsplash.com/photo-1631679706909-1844bbd07221?w=1600&q=90',
  interior4: 'https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=1600&q=90',
  cityscape: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=1600&q=90',
  building1: 'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=1600&q=90',
  building2: 'https://images.unsplash.com/photo-1464938050520-ef2270bb8ce8?w=1600&q=90',
  garden1: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1600&q=90',
};

export const heroSlides = [
  {
    image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1920&q=85',
    title: 'Luxury Home',
    subtitle: 'Faridabad & Noida',
    tag: 'Exclusive Collection',
  },
  {
    image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=1920&q=85',
    title: 'Premium Residences',
    subtitle: 'Greater Faridabad',
    tag: 'Premium Lifestyle',
  },
  {
    image: 'https://images.unsplash.com/photo-1574362848149-11496d93a7c7?w=1920&q=85',
    title: 'Multiple Storey',
    subtitle: 'Faridabad',
    tag: 'Sky-high Living',
  },
  {
    image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1920&q=85',
    title: 'Condominiums',
    subtitle: 'Outskirts of Faridabad',
    tag: 'Legacy Properties',
  },
];

export const featuredProperties = [
  {
    id: 1,
    name: 'Adore Realtech',
    location: 'Greater Faridabad',
    type: 'Luxury Villa',
    beds: null,
    baths: null,
    area: "Comfort Space",
    image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=900&q=85',
    images: [
      'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=900&q=85',
      'https://images.unsplash.com/photo-1618219908412-a29a1bb7b86e?w=900&q=85',
      'https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=900&q=85',
    ],
    tag: 'Featured',
    features: ['Prime', 'Accesible Location', 'Natural Light'],
  },
  {
    id: 2,
    name: 'BPTP Limited',
    location: 'Faridabad,Haryana',
    type: 'Multiple Storey',
    beds: null,
    baths: null,
    area: '1,500 sq ft',
    image: 'https://images.unsplash.com/photo-1574362848149-11496d93a7c7?w=900&q=85',
    images: [
      'https://images.unsplash.com/photo-1574362848149-11496d93a7c7?w=900&q=85',
      'https://images.unsplash.com/photo-1616137466211-f939a420be84?w=900&q=85',
      'https://images.unsplash.com/photo-1631679706909-1844bbd07221?w=900&q=85',
    ],
    tag: 'New',
    features: ['Multiple floors', 'Open Balconies', 'Maximize Land'],
  },
  {
    id: 3,
    name: 'Amolilk Group',
    location: 'Greater faridabad',
    type: 'Heritage',
    beds: null,
    baths: null,
    area: '10,000 sq ft',
    image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=900&q=85',
    images: [
      'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=900&q=85',
      'https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=900&q=85',
      'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=900&q=85',
    ],
    tag: 'Exclusive',
    features: ['Controlled Access', 'Stratigic Location', 'Market place'],
  },
  {
    id: 4,
    name: 'Triveni Group',
    location: 'OutSkirts of Faridabad',
    type: 'Condominiums',
    beds: null,
    baths: null,
    area: 'Max Space',
    image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=900&q=85',
    images: [
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=900&q=85',
      'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=900&q=85',
      'https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=900&q=85',
    ],
    tag: 'Prime',
    features: ['High Rise buildings', 'Parking', 'City View',],
  },
  {
    id: 5,
    name: 'Emerald Home adevelopers',
    location: 'Sector-88, Faridabad',
    type: 'Builder Floors',
    beds: null,
    baths: null,
    area: 'As per Expectations',
    image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=900&q=85',
    images: [
      'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=900&q=85',
      'https://images.unsplash.com/photo-1618219908412-a29a1bb7b86e?w=900&q=85',
      'https://images.unsplash.com/photo-1631679706909-1844bbd07221?w=900&q=85',
    ],
    tag: 'Delux',
    features: [' customizable spaces', 'Private Terrace', 'Park Facing', 'Butler Service'],
  },
  {
    id: 6,
    name: 'Omaxe Limited',
    location: 'near Omaxe city, Faridabad',
    type: 'Bungalow',
    beds: null,
    baths: null,
    area: 'as per Requirements',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&q=85',
    images: [
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&q=85',
      'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=900&q=85',
      'https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=900&q=85',
    ],
    tag: 'Garden Estate',
    features: ['Good Environment', 'Zen Garden', 'great Interior'],
  },
];

export const testimonials = [
  {
    name: 'Rajan Mehta',
    role: 'Business Tycoon, Faridabad',
    avatar: 'RM',
    text: 'Ashwanni Vashisht delivered beyond our expectations. The property curation was impeccable and the entire process seamless. Truly the finest real estate experience in Haryana.',
  },
  {
    name: 'Priya Kapoor',
    role: 'Corporate Executive, Faridabad',
    avatar: 'PK',
    text: 'We found our dream home in Faridabad through KARYA. The team\'s knowledge of the luxury market is unmatched. Every detail was handled with utmost professionalism.',
  },
  {
    name: 'Arjun Singhania',
    role: 'Tech Entrepreneur, Noida',
    avatar: 'AS',
    text: 'From NRI investment advice to final possession, Ashwini and her team were exceptional. The transparency and guidance throughout was reassuring.',
  },
];
